export const QUICK_FETCH_PROGRESS_KEY = 'OnboardingProgress';
export const QUICK_FETCH_TASKS_KEY = 'OnboardingTasks';
export const QUICK_FETCH_TREATMENT_KEY = 'TreatmentRequests';
export const QUICK_FETCH_DEMOGRAPHICS_KEY = 'DemographicsRequest';
export const QUICK_FETCH_ONBOARDING_SETTINGS_KEY = 'OnboardingSettingsRequest';